import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Create New Draw", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DrawCreateForm = _resolveComponent("DrawCreateForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog) = $event)),
    onCloseModal: _ctx.handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode(_component_DrawCreateForm, {
        onDrawCreated: _ctx.handleDrawCreated,
        onCancelForm: _ctx.handleClose
      }, null, 8, ["onDrawCreated", "onCancelForm"])
    ]),
    _: 1
  }, 8, ["modelValue", "onCloseModal"]))
}